import React, { useContext, useState, useEffect } from "react";
import SidebarData from "../components/SidebarData";
import axios from "axios";
import api from "../components/api";

export const AmazonContext = React.createContext();

export function useAmazonContext() {
  return useContext(AmazonContext);
}

export function AmazonContextProvider(props) {
  //Responsible for opening and closing the sub container
  const [subContainer, setSubContainer] = useState(false);
  //Responsible for storing the subContainers entries
  const [subContainerEntries, setSubContainerEntries] = useState(null);
  //Responsible for holding all of the data that goes into the navbar
  const [entryStore, setEntryStore] = useState(null);
  //Topic Data from BackEnd
  const [topicDatafromBackEnd, setTopicDatafromBackEnd] = useState([]);
  //Examples Data from BackEnd
  const [exampleDatafromBackEnd, setExampleDatafromBackEnd] = useState([]);
  //TopicNumbers List from BackEnd
  const [topicNumbersListfromBackEnd, setTopicNumbersListfromBackEnd] =
    useState([]);
  //Responsible for holding course Title
  const [courseTitleUserIsOn, setCourseTitleUserIsOn] = useState("");
  console.log(courseTitleUserIsOn);
  //Responsible for holding course Title
  const [courseDetails, setCourseDetails] = useState({});
  console.log(courseDetails);
  //Responsible for holding lesson number
  const [selectedLesson, setSelectedLesson] = useState({});
  console.log(courseDetails);
  //Responsible for holding user lesson Progress Data
  const [progressData, setProgressData] = useState(null);
  console.log(progressData);
  //Responsible for opening closing the side nav:
  const [navOpen, setNavOpen] = useState(false);

  //Responsible for holding user chapter Progress Data
  const [chapterProgressData, setChapterProgressData] = useState(null);
  console.log(progressData);

  //Responsible for holding user role
  const [userRole, setUserRole] = useState(null);

  //Responsible for holding lesson templates
  const [predefinedTemplates, setPredefinedTemplates] = useState([]);

  //Responsible for holding quiz  templates
  const [predefinedQuizTemplates, setPredefinedQuizTemplates] = useState([]);

  //Responsible for holding user unlocked lessons Data
  const [unlockedLessons, setUnlockedLessons] = useState(null);
  console.log(progressData);
  //Dark vs Light mode: start

  // Check if the user has a preferred mode stored in local storage
  const storedMode = localStorage.getItem("preferredMode");

  // Initialize the mode based on stored preference or set a default
  const [isDarkMode, setIsDarkMode] = useState(storedMode === "dark");

  // Update the stored preference whenever the mode changes
  // useEffect(() => {
  //   localStorage.setItem("preferredMode", isDarkMode ? "dark" : "light");
  // }, [isDarkMode]);
  // //Dark vs Light mode: end
  // //To call TopicsData from the backend which will return all topics to the front end
  // useEffect(() => {
  //   axios(`/${courseTitleUserIsOn}/topicsData`).then((response) => {
  //     setTopicDatafromBackEnd(response.data);
  //     console.log(response.data);
  //   });
  // }, []);

  // //To call ExamplesData from the backend which will return all topics to the front end
  // useEffect(() => {
  //   axios(`/examplesData`).then((response) => {
  //     setExampleDatafromBackEnd(response.data);
  //   });
  // }, []);

  // //To call ExamplesData from the backend which will return all examples to the front end
  // useEffect(() => {
  //   axios(`/${courseTitleUserIsOn}/sideBarData`).then((response) => {
  //     setEntryStore(response.data);
  //   });
  // }, []);

  // //To call TopicNumbers from the backend which will return all topics numbers to the front end
  // useEffect(() => {
  //   axios(`/${courseTitleUserIsOn}/topicNumbersList`).then((response) => {
  //     setTopicNumbersListfromBackEnd(response.data);
  //   });
  // }, []);

  // useEffect(() => {
  //   fetch("https://amazon-navbar.herokuapp.com/fetch")
  //     .then((response) => response.json())
  //     .then((response) => {
  //       setEntryStore(response);
  //       // console.log(response);
  //     });
  // }, []);

  // New Code

  // const SidebarData = [
  //   {
  //     entries: [
  //       {
  //         topicNumber: "1.1",
  //         title: "The purpose of this course",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "1.2",
  //         title: "Qalimah",
  //         rows: false,
  //       },
  //     ],
  //     _id: "60ab69680a5705404d68d9f9",
  //     title: "Why Arabic?",
  //     topicHeaderNumber: "1",
  //     type: {
  //       _id: "61a049aaad966900153a0659",
  //       rows: true,
  //       dropDown: false,
  //     },
  //   },
  //   {
  //     entries: [
  //       {
  //         topicNumber: "2.1.1",
  //         title: "Ism Muntharif",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "2.1.2",
  //         title: "Gair Muntharif Asma",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "2.1.3",
  //         title: "Mabni Asma",
  //         rows: false,
  //       },
  //     ],
  //     _id: "60ab69ee0a5705404d68d9fc",
  //     title: "I'araab",
  //     topicHeaderNumber: "2.1",
  //     type: {
  //       _id: "61a049aaad966900153a065a",
  //       rows: true,
  //       dropDown: false,
  //     },
  //   },
  //   {
  //     entries: [
  //       {
  //         topicNumber: "2.2.1",
  //         title: "Mu'annath",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "2.2.2",
  //         title: "Mu'anath Haqeeqi",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "2.2.3",
  //         title: "Mu'anath Gair Haqeeqi",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "1.2.1.1",
  //         title: "Mua'nath Alamati",
  //         rows: true,
  //         entries: [
  //           {
  //             topicNumber: "1.2.1.1",
  //             title: "Mua'nath Alamati",
  //             entries: [
  //               {
  //                 sectionNumber: "1.2.1.1.1",
  //                 title: "Gol Ta ة",
  //               },
  //               {
  //                 sectionNumber: "1.2.1.1.2",
  //                 title: "Alif Mamdoodah اء",
  //               },
  //               {
  //                 sectionNumber: "1.2.1.1.3",
  //                 title: "Alif Maqthoorah اى",
  //               },
  //             ],
  //           },
  //         ],
  //       },
  //       {
  //         topicNumber: "2.2.4",
  //         title: "Mua'nath Samai",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "2.2.5",
  //         title: "How to convert Muthakkar to Mu'anath",
  //       },
  //     ],
  //     _id: "60ab6a260a5705404d68d9fd",
  //     title: "Jins",
  //     topicHeaderNumber: "2.2",
  //     type: {
  //       _id: "61a049aaad966900153a065b",
  //       rows: false,
  //       dropDown: false,
  //     },
  //   },
  //   {
  //     entries: [
  //       {
  //         topicNumber: "2.3.1",
  //         title: "Wahid",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "2.3.2",
  //         title: "Muthanna",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "2.3.3",
  //         title: "Jam'a",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "2.3.4",
  //         title: "Jam'a Saalim",
  //         rows: true,
  //         entries: [
  //           {
  //             topicNumber: "2.3.5",
  //             title: "Jam'a Saalim",
  //             entries: [
  //               {
  //                 sectionNumber: "2.3.5.1",
  //                 title: "Jam'a Saalim Muthakkar",
  //               },
  //               {
  //                 sectionNumber: "2.3.5.2",
  //                 title: "Jama'a Saalim Mu'annath",
  //               },
  //             ],
  //           },
  //         ],
  //       },
  //       {
  //         topicNumber: "2.3.6",
  //         title: "Jam'a Saalim Chart",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "2.3.7",
  //         title: "Jam'a Mukassar",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "2.3.8",
  //         title: "Jam'a Mukassar Chart",
  //         rows: false,
  //       },
  //     ],
  //     _id: "60ab6a260a5705404d68d9fd",
  //     title: "Adad",
  //     topicHeaderNumber: "2.3",
  //     type: {
  //       _id: "61a049aaad966900153a065b",
  //       rows: true,
  //       dropDown: false,
  //     },
  //   },
  //   {
  //     entries: [
  //       {
  //         topicNumber: "2.4.1",
  //         title: "Test Chart",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "3.1.1.1",
  //         title: "Mu'arifah",
  //         rows: true,
  //         entries: [
  //           {
  //             topicNumber: "3.1.1.1",
  //             title: "Mu'arifah",
  //             entries: [
  //               {
  //                 sectionNumber: "3.1.1.1.1",
  //                 title: "Ism Alam",
  //               },
  //               {
  //                 sectionNumber: "3.1.1.1.2",
  //                 title: "Ism Zamaa'ir",
  //               },
  //               {
  //                 sectionNumber: "3.1.1.1.3",
  //                 title: "Ism Ishaari",
  //               },
  //               {
  //                 sectionNumber: "3.1.1.1.4",
  //                 title: "Ism Mawthoola",
  //               },
  //             ],
  //           },
  //         ],
  //       },
  //       {
  //         topicNumber: "2.4.2",
  //         title: "Nakirah",
  //       },
  //       {
  //         topicNumber: "2.4.3",
  //         title: "Mua'rifah billam (How to make nakirah to Mua'rifah)",
  //         rows: false,
  //       },
  //       {
  //         topicNumber: "2.4.4",
  //         title: "How would Al react with different forms of Ism",
  //         rows: true,
  //         entries: [
  //           {
  //             topicNumber: "2.4.4",
  //             title: "How would Al react with different forms of Ism",
  //             entries: [
  //               {
  //                 sectionNumber: "2.4.4.1",
  //                 title: "Gair Muntharif Asma reacting to Al",
  //               },
  //               {
  //                 sectionNumber: "2.4.4.2",
  //                 title: "Ism Muthanna reacting to Al",
  //               },
  //               {
  //                 sectionNumber: "2.4.4.3",
  //                 title: "Jam'a reacting to Al",
  //               },
  //               {
  //                 sectionNumber: "2.4.4.4",
  //                 title: "Jama'a Saalim reacting to Al",
  //               },
  //               {
  //                 sectionNumber: "2.4.4.5",
  //                 title: "Jama'a Mukassar reacting to Al",
  //               },
  //               {
  //                 sectionNumber: "2.4.4.6",
  //                 title: "Mabni Asma Reacting to Al",
  //               },
  //             ],
  //           },
  //         ],
  //       },
  //       {
  //         topicNumber: "2.4.5",
  //         title: "Some things about Al",
  //         rows: true,
  //         entries: [
  //           {
  //             topicNumber: "2.4.5",
  //             title: "Some things about Al",
  //             entries: [
  //               {
  //                 sectionNumber: "2.4.5.1",
  //                 title: "Components of Al",
  //               },
  //               {
  //                 sectionNumber: "2.4.5.2",
  //                 title: "When to pronounce L (Kamri vs Shamsi Huruf)",
  //               },
  //               {
  //                 sectionNumber: "2.4.5.3",
  //                 title: "Arabs sometimes make an exception",
  //               },
  //             ],
  //           },
  //         ],
  //       },
  //     ],
  //     _id: "60ab6a260a5705404d68d9fd",
  //     title: "Wus'at",
  //     topicHeaderNumber: "2.4",
  //     type: {
  //       _id: "61a049aaad966900153a065b",
  //       rows: false,
  //       dropDown: false,
  //     },
  //   },
  // ];

  //Decide here which SidebarData to send to application:

  // useEffect(() => {
  //   setEntryStore(SidebarData);
  // }, []);

  // Sending all the important data above as values in other parts of the application:

  const toggleMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    // Store the preference in localStorage
    localStorage.setItem("preferredMode", newMode ? "dark" : "light");
  };

  //Responsible for managing update modal state
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateInfo, setUpdateInfo] = useState(null);
  const [showCompletionModal, setShowCompletionModal] = useState(false);

  //Responsible for managing streak state
  const [showStreakModal, setShowStreakModal] = useState(false);
  const [currentStreak, setCurrentStreak] = useState(0);
  const [longestStreak, setLongestStreak] = useState(0);
  const [streakData, setStreakData] = useState(null);
  // "active" | "frozen" | "none"
  const [streakStatus, setStreakStatus] = useState("none");
  // While frozen: { frozenStreak, lessonsCompleted, lessonsRequired, expiresOn, expiresAt, daysLeft }
  const [streakRecovery, setStreakRecovery] = useState(null);
  const [showStreakFrozenModal, setShowStreakFrozenModal] = useState(false);
  // Set to the old streak count when a frozen streak is reclaimed, so StreakModal can celebrate it
  const [streakRestoredFrom, setStreakRestoredFrom] = useState(null);

  //Responsible for managing lessons count state
  const [totalLessons, setTotalLessons] = useState(0);

  // Fetch user streak data
  const fetchUserStreak = async () => {
    try {
      const userEmail = localStorage.getItem("userEmail");
      if (!userEmail) return;

      // Detect user's timezone
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const response = await api.get("/getUserStreak", {
        params: { 
          userEmail,
          timezone: userTimezone
        },
      });

      if (response.data) {
        setCurrentStreak(response.data.currentStreak);
        setLongestStreak(response.data.longestStreak);
        const isFrozen = response.data.status === "frozen" && response.data.recovery;
        setStreakStatus(
          isFrozen ? "frozen" : response.data.currentStreak > 0 ? "active" : "none"
        );
        setStreakRecovery(isFrozen ? response.data.recovery : null);
      }
    } catch (error) {
      console.error("Error fetching user streak:", error);
    }
  };

  // Applies the `streak` object returned by the progress endpoints: shows the streak
  // modal for a new or reclaimed streak, or updates the freeze recovery tracker.
  const applyStreakResponse = (streak, modalDelayMs = 2000) => {
    if (!streak) return;

    if (streak.streakRestored) {
      setCurrentStreak(streak.currentStreak);
      if (streak.longestStreak !== undefined) setLongestStreak(streak.longestStreak);
      setStreakStatus("active");
      setStreakRecovery((prev) =>
        prev ? { ...prev, lessonsCompleted: prev.lessonsRequired, restored: true } : prev
      );
      setTimeout(() => {
        setStreakRecovery(null);
        setStreakRestoredFrom(streak.restoredFrom);
        setShowStreakModal(true);
      }, modalDelayMs);
      return;
    }

    if (streak.status === "frozen" && streak.recovery) {
      setCurrentStreak(streak.currentStreak);
      setStreakStatus("frozen");
      setStreakRecovery(streak.recovery);
      return;
    }

    if (streak.isNewStreak) {
      setCurrentStreak(streak.currentStreak);
      setStreakStatus("active");
      setStreakRecovery(null);
      setTimeout(() => {
        setShowStreakModal(true);
      }, modalDelayMs);
    }
  };

  // Fetch user lesson count
  const fetchUserLessons = async () => {
    try {
      const userEmail = localStorage.getItem("userEmail");
      if (!userEmail) return;

      const response = await api.get("/getUserLessonsCount", {
        params: { userEmail },
      });

      if (response.data) {
        setTotalLessons(response.data.totalLessons);
      }
    } catch (error) {
      console.error("Error fetching user lessons:", error);
    }
  };

  const contextValue = {
    subContainer,
    setSubContainer,
    subContainerEntries,
    setSubContainerEntries,
    entryStore,
    setEntryStore,
    topicDatafromBackEnd,
    setTopicDatafromBackEnd,
    exampleDatafromBackEnd,
    setExampleDatafromBackEnd,
    topicNumbersListfromBackEnd,
    setTopicNumbersListfromBackEnd,
    courseTitleUserIsOn,
    setCourseTitleUserIsOn,
    courseDetails,
    setCourseDetails,
    selectedLesson,
    setSelectedLesson,
    isDarkMode,
    setIsDarkMode,
    progressData,
    setProgressData,
    chapterProgressData,
    setChapterProgressData,
    navOpen,
    setNavOpen,
    predefinedTemplates,
    setPredefinedTemplates,
    userRole,
    setUserRole,
    predefinedQuizTemplates,
    setPredefinedQuizTemplates,
    toggleMode,
    showUpdateModal,
    setShowUpdateModal,
    updateInfo,
    setUpdateInfo,
    showCompletionModal,
    setShowCompletionModal,
    // Streak-related context values
    showStreakModal,
    setShowStreakModal,
    currentStreak,
    setCurrentStreak,
    longestStreak,
    setLongestStreak,
    streakData,
    setStreakData,
    fetchUserStreak,
    streakStatus,
    setStreakStatus,
    streakRecovery,
    setStreakRecovery,
    showStreakFrozenModal,
    setShowStreakFrozenModal,
    streakRestoredFrom,
    setStreakRestoredFrom,
    applyStreakResponse,
    // Lessons-related context values
    totalLessons,
    setTotalLessons,
    fetchUserLessons,
  };

  return (
    <AmazonContext.Provider value={contextValue}>
      {props.children}
    </AmazonContext.Provider>
  );
}
